export default "__VITE_ASSET__54e48a6a__"